<template>
    <div class="ticket-resolve-layout">
        <div class="logo">
            <img v-if="this.logo === 'connect'" src="@/assets/images/logo.png" class="w-100 mb-4" />
            <img v-if="this.logo === 'lab'" src="@/assets/images/transparent-1000.png" class="w-100 mb-4" />
        </div>

        <div v-if="ticketData && ticketData.status === STATUS_RESOLVED" class="content-row">
            <div class="row align-items-center">
                <div class="col">
                    <div class="text-left">The issue has been resolved. No further action required.</div>
                    <button v-if="$store.state.isSignedIn" class="btn btn-primary mt-3" @click="$router.push({ name: 'Dashboard' })">
                        Dashboard
                    </button>
                    <button v-else class="btn btn-primary mt-3" @click="$router.push({ name: 'Signin' })">
                        Sign In
                    </button>
                </div>
            </div>
        </div>

        <div v-else-if="ticketData && orderData" class="bg-white mb-3">
            <div class="d-flex justify-content-between align-items-center">
                <div>
                    <h1 class="h4 mb-0">Resolve Issue - {{ orderData.patient_name }}</h1>
                </div>
            </div>
        </div>

        <div v-if="ticketData && ticketData.status !== STATUS_RESOLVED" class="ticket-list mb-4">
            <!-- Issue -->
            <div class="header-row">
                <div class="row">
                    <div class="col">
                        Issue
                    </div>
                </div>
            </div>
            <div class="content-row">
                <div class="row">
                    <div class="col">
                        {{ ticketData.type.name }}
                    </div>
                </div>
            </div>

            <!-- Reason -->
            <div v-if="ticketData.reason" class="header-row mt-2">
                <div class="row">
                    <div class="col">
                        Reason
                    </div>
                </div>
            </div>
            <div v-if="ticketData.reason" class="content-row">
                <div class="row">
                    <div class="col">
                        {{ ticketData.reason.ticket_reason_name }}
                    </div>
                </div>
            </div>

            <!-- Notes -->
            <div v-if="ticketData.notes && ticketData.was_improved_with_ai" class="header-row mt-2">
                <div class="row">
                    <div class="col">
                        Note
                    </div>
                </div>
            </div>
            <div v-if="ticketData.notes && ticketData.was_improved_with_ai" class="content-row">
                <div class="row">
                    <div class="col">
                        {{ ticketData.notes }}
                    </div>
                </div>
            </div>
            <br>
            <div v-if="resolved">
                <div class="content-row">
                    <div class="row align-items-center">
                        <div class="col">
                            <div class="text-left">Thank you! The issue has been resolved.</div>
                                <button class="btn btn-primary mt-3" @click="$router.push({ name: 'Signin' })">
                                    Sign In
                                </button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else-if="ticketData" class="content-row">
                <!-- Form -->
                <form v-if="ticketData.can_resolve" enctype="multipart/form-data" novalidate class="bg-white" @submit.prevent="submitTicket">

                    <!-- Options -->
                    <div v-if="ticketData.reason && ticketData.reason.options && ticketData.reason.options.length"  class="col mb-2">
                        <DropdownInput
                        label="Please select an option"
                        v-model="dentistOption"
                        :v="v$.dentistOption"
                        :options="ticketData.reason.options.map(option => ({ id: option.id, label: option.preferred ? `${option.name} (preferred)` : option.name }))"
                        />
                    </div>

                    <!-- Modal -->
                    <div class="modal fade" id="send-imp-modal" tabindex="-1">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Information</h5>
                                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                                </div>
                                <div class="modal-body" v-if="selectedOption">
                                    <p><strong>{{ selectedOption.name }}</strong></p>
                                    <p v-if="selectedOption.is_sending_new_impressions">By selecting this option, you are indicating that you will send new impressions or scans. We will keep this order suspended until the new impressions are received.</p>
                                    <p v-else>By selecting this option, we will continue with this order.</p>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Ok</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="ticketData && ticketData.is_missing_standard" class="col mb-2">
                        <DropdownInput
                            label="Service level"
                            v-model="standard"
                            :v="v$.standard"
                            :options="standards"
                        />
                    </div>

                    <div v-if="ticketData.is_missing_shade">
                        <div class="col-sm-5 col-md-5 mb-2">
                            <TextInput
                                label="Shade"
                                maxlength="10"
                                v-model="shade"
                                :v="v$.shade"
                            />
                        </div>
                    </div>

                    <div v-if="ticketData.is_production_delay">
                        <div class="mb-2">
                            <DateInput
                                :label="patientAppointmentDateLabel"
                                v-model="patientAppointmentDate"
                                :v="v$.patientAppointmentDate"
                                :min="todayIso"
                            />
                            <div v-if="isDeliveredBeforePatientDate" class="text-success small">
                                <i class="bi bi-check-circle"></i> Scheduled delivery is before patient appointment date
                            </div>
                        </div>
                    </div>

                    <div class="content-row">
                        <div class="row align-items-center">
                            <div class="col">
                                <div class="text-left">*If you need any more information please contact the lab.</div>
                            </div>
                        </div>
                    </div>

                    <div class="buttons button-div mt-4">
                        <button class="btn btn-primary me-1" type="submit">Save</button>
                        <button class="btn btn-secondary me-1" type="button" @click="$router.push({ name: 'Signin' })">Cancel</button>
                    </div>
                </form>

                <!-- Files Gallery -->
                <div v-if="filesData && filesData.length" style="clear:both;">
                    <div class="row files-row mt-4">
                        <h2 class="h5 mt-3 mb-3 page-section-heading">Uploaded Files</h2>
                        <LightboxGallery :files="filesData" />
                    </div>
                </div>
            </div>
           
            <div v-else>
                <div class="content-row">
                    <div class="row align-items-center">
                        <div class="col">
                            <div class="text-center">This issue cannot be resolved online. Please contact the lab.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- if theres to ticket data display a generic message-->
        <div v-else-if="!loading && !ticketData">
            <div class="content-row">
                <div class="row align-items-center">
                    <div class="col">
                        <div class="text-center">Unable to load ticket information. Please contact the lab.</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal patient date before expected delivery -->
    <div class="modal fade" id="patient-date-before-delivery-modal" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Information</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <p>The patient appointment date you have chosen is before the expected delivery date of this order.</p>
                    <p v-if="orderData">Expected delivery date: <strong>{{ $filters.formatDate(orderData.expected_delivery_date) }}</strong></p>
                    
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="acceptNewDate">Accept</button>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal new patient date -->
    <div class="modal fade" id="patient-date-modal" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Information</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body" v-if="newPatientDate">
                    <p><strong>Delivery Date</strong></p>
                    <p>Unfortunately we need to change the delivery date of your order due to delays.</p>
                    <p>Your new delivery date {{ newPatientDate }}</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" id="ok-patient-date-button">Ok</button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
     .ticket-list
    {
        list-style: none;
        padding: 0px;
        margin: 0px;

        > .content-row
        {
            border-top: 1px solid #EEEEEE;
            padding: 10px 0px;

            strong
            {
                color: $swift-dark-grey;
            }
        }

        .header-row
        {
            border-top: 0px;
        }
    }

    .files-row
    {
        border-top: 1px solid #EEEEEE;
        border-bottom: 1px solid #EEEEEE;
        padding: 10px 0px;

        strong
        {
            color: $swift-dark-grey;
        }
    }

    .uploaded-file
    {
        border: $border-width*2 solid $swift-lighter-grey;
        @include border-radius($border-radius);
        padding: calc($spacer / 2) $spacer;

        a
        {
            display: block;
        }
    }

    .ticket-resolve-layout
    {
        max-width: 600px;
        width: 100%;
        margin: auto;
        margin-top: 5vh;
        margin-bottom: 2rem;
    }

     .ticket-resolve-layout .logo
    {
        max-width: 400px;
        width: 100%;
        margin: auto;
        margin-top: 10vh;
        margin-bottom: 2rem;
    }
</style>

<script>
    import api from "@/services/api";
    import DropdownInput from '@/components/DropdownInput.vue';
    import TextInput from '@/components/TextInput.vue';
    import DateInput from '@/components/DateInput.vue';
    import LightboxGallery from '@/components/LightboxGallery.vue';
    import useVuelidate from '@vuelidate/core';
    import { helpers, requiredIf } from '@vuelidate/validators';
    import { Modal } from 'bootstrap';

    const STATUS_RESOLVED = 2;

    export default {
        props: {
            code: {
                required: true
            },
            logo: {
                default: 'connect',
            }
        },
        setup () {
            return {
                v$: useVuelidate()
            }
        },
        data() {
            return {
                ticketData: null,
                orderData: null,
                standards: [],
                standard: '',
                shade: '',
                patientAppointmentDate: '',
                patientDateConfirmed: false,
                dentistOption: '',
                statuses:[{id:true, label:'Yes'}, {id:false, label:'No'}],
                filesData: null,
                selectedOption: null,
                resolved: false,
                loading: true,
                STATUS_RESOLVED,
                newPatientDate: null,
            };
            
        },
        computed: {
            todayIso() {
                const now = new Date();
                const tzOffsetMs = now.getTimezoneOffset() * 60000;
                return new Date(now - tzOffsetMs).toISOString().slice(0, 10);
            },
            patientAppointmentDateLabel() {
                const base = 'Enter patient appointment date';
                if (this.patientDateConfirmed && this.orderData && this.orderData.expected_delivery_date) {
                    return `${base}  | delivery date: ${this.$filters.formatDate(this.orderData.expected_delivery_date)}`;
                }
                return base;
            },
            isDeliveredBeforePatientDate() {
                if (!this.patientAppointmentDate || !this.orderData || !this.orderData.expected_delivery_date) {
                    return false;
                }
                return new Date(this.patientAppointmentDate) > new Date(this.orderData.expected_delivery_date);
            },
        },
        validations () {
            return {
                standard: { requiredIf: requiredIf( this.ticketData && this.ticketData.is_missing_standard) },
                shade: { requiredIf: requiredIf( this.ticketData && this.ticketData.is_missing_shade) },
                patientAppointmentDate: {
                    requiredIf: requiredIf(this.ticketData && this.ticketData.is_production_delay),
                    afterExpectedDelivery: helpers.withMessage(
                        'Patient appointment date must be at least 1 day after the expected delivery date',
                        (value) => {
                            if (!value || !this.orderData || !this.orderData.expected_delivery_date) {
                                return true;
                            }
                            const chosen = new Date(value);
                            const minAllowed = new Date(this.orderData.expected_delivery_date);
                            minAllowed.setDate(minAllowed.getDate() + 1);
                            return chosen >= minAllowed;
                        }
                    ),
                },
                dentistOption: { requiredIf: requiredIf(this.ticketData && this.ticketData.reason && this.ticketData.reason.options && this.ticketData.reason.options.length) },
            }
        },
        components: {
            DropdownInput,
            TextInput,
            DateInput,
            LightboxGallery,
        },
        mounted () {
            this.fetchTicketAccess(); // First ticket from the token
        },
        watch: {
            patientAppointmentDate(newDate) {
                if (!newDate || this.patientDateConfirmed || !this.orderData || !this.orderData.expected_delivery_date) {
                    return;
                }
                if (new Date(newDate) < new Date(this.orderData.expected_delivery_date)) {
                    const modalEl = document.getElementById('patient-date-before-delivery-modal');
                    if (!this.patientDateBeforeDeliveryModalInstance && modalEl) {
                        this.patientDateBeforeDeliveryModalInstance = new Modal(modalEl);
                    }
                    this.patientDateBeforeDeliveryModalInstance?.show();
                }
            },
            dentistOption(newOption) {
                if (newOption && this.ticketData && this.ticketData.type.ask_impression_model_question ) {
                    const selected = this.ticketData.reason.options.find(opt => opt.id == newOption);
                    this.selectedOption = selected;

                    const sendImpModal = document.getElementById('send-imp-modal')
                    if (!this.sendImpModalInstance && sendImpModal) {
                        this.sendImpModalInstance = new Modal(sendImpModal)
                    }
                    this.sendImpModalInstance?.show()
                }
            }
        },
        methods: {       
            acceptNewDate() {
                if (!this.orderData || !this.orderData.expected_delivery_date) {
                    return;
                }
                const next = new Date(this.orderData.expected_delivery_date);
                next.setDate(next.getDate() + 1);
                const tzOffsetMs = next.getTimezoneOffset() * 60000;
                this.patientAppointmentDate = new Date(next - tzOffsetMs).toISOString().slice(0, 10);
                this.patientDateConfirmed = true;
            },
            fetchTicketAccess() {
                api.get('/api/v1/tickets/access/' + this.code)
                .then((response) => {
                    this.ticketData = response.data.ticket;
                    this.orderData = response.data.order;
                    this.filesData = response.data.files;
                    this.fetchStandards();
                })
                .catch((error) => {
                    console.error('Error fetching ticket:', error);
                })
                .finally(() => {
                    this.loading = false;
                });
            },
            fetchStandards: function() {                
                this.standards = [{
                    id: 1,
                    label: 'NHS / Standard',
                }, {
                    id: 2,
                    label: 'Independent',
                }, {
                    id: 3,
                    label: 'Private',
                }]
            },
            submitTicket: async function() {
                var isValid = await this.v$.$validate();

                if(isValid)
                {
                    this.submitResolve();
                }
                else
                {
                    console.log('Validation errors', this.v$.$errors.map((error) => { return error.$property + ': ' + error.$message}));
                }
            },
            submitResolve: function() {
                // Submit ticket to api
                var data = {
                    'userId': this.userId,
                    'standard': this.standard,
                    'shade': this.shade,
                    'patientAppointmentDate': this.patientAppointmentDate,
                    'dentistOption': this.dentistOption,
                };

                api
                .post('/api/v1/tickets/access/' + this.code + '/resolve', data)
                .then((response) => {
                    if (response.data.patient_date_updated == true) {
                        this.newPatientDate = this.$filters.formatDate(response.data.new_patient_date);
                        const patientDateModal = document.getElementById('patient-date-modal')
                        if (!this.patientDateModalInstance && patientDateModal) {
                            this.patientDateModalInstance = new Modal(patientDateModal)
                        }
                        this.patientDateModalInstance?.show()

                        document.getElementById('ok-patient-date-button').addEventListener('click', () => {
                            this.resolved = true;
                        });
                    }
                    console.log(response);
                    this.resolved = true;
                })
                .catch(() => {
                    console.log('Catch ticket resolve error');
                });
            },
            fetchFilesData: function() {                
                api
                .get('/api/v1/tickets/' + this.ticketId + '/files')
                .then((response) => {
                    this.filesData = response.data.data;
                })
                .catch(() => {
                    console.log('Catch files error');
                });
            },
        },
    }
</script>